const conditionMatchPropsData = require('./conditionMatchPropsData');

const propIsNull = (value) => {
  return (
    value === null ||
    value === '' ||
    value === undefined ||
    (Array.isArray(value) && value.length === 0)
  );
};

const conditionMatchForApp = ({
  handleDataIndex, // 当前操作的属性index
  propData, // 当前的属性数据
  userMap, // 用户信息map { userid:{ nick_name:xxxx } }
  template, // 当前模板
  templateList = null, // 空间模板列表
  matchConfig, // 可选，已经通过getConditionMatchProps匹配的数据
  creator = null, //创建者
  title = '', //标题
}) => {
  const [newData, changedFields] = conditionMatchPropsData({
    handleDataIndex, // 当前操作的属性index
    propData, // 当前的属性数据
    userMap, // 用户信息map { userid:{ nick_name:xxxx } }
    template, // 当前模板
    templateList, // 空间模板列表
    matchConfig, // 可选，已经通过getConditionMatchProps匹配的数据
    creator, //创建者
    title,
    changedFields: [handleDataIndex],
  });
  return {
    propData: newData.map((prop) => {
      if (Array.isArray(prop)) {
        return prop;
      }
      return propIsNull(prop)
        ? []
        : typeof prop === 'object'
        ? [JSON.stringify(prop)]
        : [prop.toString()];
    }),
    changedFields: changedFields,
  };
};
module.exports = { conditionMatchForApp, propIsNull };
